import r from"./indexed-object.js";import t from"./require-object-coercible.js";var o=r,c=t,i=function(e){return o(c(e))};export{i as default};
